import useLogoutUser from 'CustomHooks/useLogoutUser';
import React, { useEffect } from 'react';

function Logout() {
  const logout = useLogoutUser();

  useEffect(() => {
    logout();
  }, []);

  return <></>;
}
export default Logout;
